import React from "react";
import { RaiseQueryForm } from "../../components/RaiseQueryForm";

/* Reachable signed-in and signed-out; Layout supplies the header offsets in both cases. */
export const RaiseQueryPage = () => {
  return (
    <div className="zs-page zs-page-narrow">
      <RaiseQueryForm />
    </div>
  );
};
